/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-03-14
 * @Description: 图文稿详情
 */
'use strict';
angular.module("imageTextDetailModule",[]).
controller('imageTextDetailCtrl', ['$scope', '$element', '$stateParams', '$q', '$compile', 'httpService', 'modalDialog', 'ueditorService', '$validation', 'localStorageService', '$timeout','$sce', function($scope, $element, $stateParams, $q, $compile, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout,$sce) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
        	isBackstage: false, //区分后台和前台
        };
        $scope.listData = [];
        $scope.params = {
            articleId: $stateParams.articleId
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        requestData()
    }
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/pgcArticle/findById.do", $scope.params, "get").then(function(data) {
            $scope.listData = data.articeInfo;
            $scope.listData.articleHtmlCon = $sce.trustAsHtml(data.articeInfo.articleHtmlCon);
            $scope.status.channels = data.chnlsAndTags;
        });
    }
    /**
     * [initCover description] 初始化封面
     * @param  {[type]} item [description] 渠道信息
     * @return {[type]}      [description]
     */
    $scope.initCover = function(item) {
        item.coverImg = JSON.parse(item.coverImg);
    };
}]);